import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-upload-report',
  templateUrl: './upload-report.page.html',
  styleUrls: ['./upload-report.page.scss'],
})
export class UploadReportPage implements OnInit {

  constructor(
    public router:Router,
    public modalCtrl:ModalController,
    public addCall: AddCall,
  ) { }

  ngOnInit() {
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }


  closeToReportPage(){
    this.router.navigate(['/tabs/report']);
  }
  uploadReport(){
    // this.AlertInfo("Report Uploaded Successfully",1);
    this.AlertInfo(this.addCall.title456,1);
    this.router.navigate(['/tabs/report']);
  }
}
